import * as types from '../../../actions/actiontypes';
import {getNameOfStatusCount} from '../../../components/DashboardV2/MultiEntity/Common/HelperFunctions';
import {HttpStatusCodes, TaskCategories} from '../../../util/uiconstants';
import _ from 'lodash';
export default function multiEntityDashboardReducer(state = {}, action) {
	switch (action.type) {
		case types.GET_TASK_OVERVIEW_COUNT: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);
				const nameOfStatusCount = getNameOfStatusCount(action.view);

				if (action.taskCategoryId === TaskCategories.ScopeStrategy) {
					tempState[TaskCategories.ScopeStrategy] = {
						...tempState[TaskCategories.ScopeStrategy],
						[nameOfStatusCount]: {
							...action.response[nameOfStatusCount].filter((a) => a.uiGroupId == 1)[0],
							apiLoaded: true
						},
						items: null
					};

					tempState[TaskCategories.ExecutionGeneral] = {
						...tempState[TaskCategories.ExecutionGeneral],
						[nameOfStatusCount]: {
							...action.response[nameOfStatusCount].filter((a) => a.uiGroupId == 2)[0],
							apiLoaded: true
						},
						items: null
					};

					tempState[TaskCategories.Conclusion] = {
						...tempState[TaskCategories.Conclusion],
						[nameOfStatusCount]: {
							...action.response[nameOfStatusCount].filter((a) => a.uiGroupId == 3)[0],
							apiLoaded: true
						},
						items: null
					};
				} else {
					tempState[action.taskCategoryId] = {
						...tempState[action.taskCategoryId],
						[nameOfStatusCount]: {...action.response[nameOfStatusCount][0], apiLoaded: true},
						items: null
					};
				}
				return tempState;
			}
			return state;
		}

		case types.GET_LEVEL2_COUNTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);
				const nameOfStatusCount = getNameOfStatusCount(action.view);
				const items = tempState[action.taskCategoryId]?.items || {};

				action.response[nameOfStatusCount].forEach((e) => {
					items[e.uiGroupId] = {...items[e.uiGroupId], [nameOfStatusCount]: {...e, isLoaded: true}};
				});

				// setting is loaded for items that have zero counts and are not returned in response.
				action.ids.forEach((id) => {
					if (items[id]?.[nameOfStatusCount] !== undefined) {
						items[id][nameOfStatusCount].isLoaded = true;
					} else {
						items[id] = {...items[id], [nameOfStatusCount]: {isLoaded: true}};
					}
				});

				const ids = tempState[action.taskCategoryId]?.ids
					? new Set([...tempState[action.taskCategoryId]?.ids, ...action.ids])
					: new Set(action.ids);
				// setting updated items for taskCategory.
				tempState[action.taskCategoryId] = {
					...tempState[action.taskCategoryId],
					items: items,
					ids: ids
				};

				return tempState;
			}
			return state;
		}
		case types.GET_ALL_SCOTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				const listOfScots = action.response.data;
				// making ids as set to avoid duplicate ids;
				let ids = tempState[TaskCategories.ExecutionSCOTs]?.ids ?? new Set();
				let items = {...tempState[TaskCategories.ExecutionSCOTs]?.items};
				// let ids = new Set();
				// let items = {};

				listOfScots?.forEach((e) => {
					items[e.id] = {...items[e.id], ...e};
					ids.add(e.id);
				});

				tempState[TaskCategories.ExecutionSCOTs] = {
					...tempState[TaskCategories.ExecutionSCOTs],
					items: items,
					ids: ids,
					...action.response
				};
				return tempState;
			}
			return state;
		}
		case types.GET_ALL_ACCOUNTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				const listOfAccounts = action.response.data;
				// making ids as set to avoid duplicate ids;
				let ids = tempState[TaskCategories.ExecutionAccounts]?.ids ?? new Set();
				let items = {...tempState[TaskCategories.ExecutionAccounts]?.items};

				listOfAccounts?.forEach((e) => {
					items[e.id] = {...items[e.id], ...e};
					ids.add(e.id);
				});

				tempState[TaskCategories.ExecutionAccounts] = {
					...tempState[TaskCategories.ExecutionAccounts],
					items: items,
					ids: ids,
					...action.response
				};
				return tempState;
			}
			return state;
		}

		case types.GET_All_RISKS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				const listOfAccounts = action.response.data.filter((x) => x.riskTypeId !== 3);

				// making ids as set to avoid duplicate ids;
				let ids = tempState[TaskCategories.Risks]?.ids ?? new Set();
				let items = {...tempState[TaskCategories.Risks]?.items};

				listOfAccounts?.forEach((e) => {
					items[e.id] = {...items[e.id], ...e};
					ids.add(e.id);
				});

				tempState[TaskCategories.Risks] = {
					...tempState[TaskCategories.Risks],
					items: items,
					ids: ids,
					...action.response
				};
				return tempState;
			}
			return state;
		}

		case types.GET_ALL_TASK_SECTIONS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				const listOfAccounts = action.response;

				// making ids as set to avoid duplicate ids;
				let ids = tempState[TaskCategories.TaskSection]?.Ids ?? new Set();
				let items = {...tempState[TaskCategories.TaskSection]};

				listOfAccounts?.forEach((e) => {
					items[e.taskSectionId] = {...items[e.taskSectionId], ...e};
					ids.add(e.taskSectionId);
				});

				tempState[TaskCategories.TaskSection] = {
					...tempState[TaskCategories.TaskSection],
					items: items,
					ids: ids,
					...action.response
				};
				return tempState;
			}
			return state;
		}

		case types.GET_ALL_IT_PROCESSES: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);
				const listOfAccounts = action.response.data;

				// making ids as set to avoid duplicate ids;
				let ids = tempState[TaskCategories.ExecutionITSOs]?.ids ?? new Set();
				let items = {...tempState[TaskCategories.ExecutionITSOs]?.items};

				listOfAccounts?.forEach((e) => {
					items[e.id] = {...items[e.id], ...e};
					ids.add(e.id);
				});

				tempState[TaskCategories.ExecutionITSOs] = {
					...tempState[TaskCategories.ExecutionITSOs],
					items: items,
					ids: ids,
					...action.response
				};
				return tempState;
			}
			return state;
		}

		case types.GET_ALL_UNASSIGNED_COUNT: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				tempState[TaskCategories.UnassignedAssignment] = {
					...tempState[TaskCategories.UnassignedAssignment],
					apiLoaded: true,
					count: action.response.countAssignmentStatusUnassigned
				};
				return tempState;
			}
			return state;
		}

		case types.GET_ALL_UNRELATED_REQUESTS_COUNT: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				tempState[TaskCategories.UnrelatedRequests] = {
					...tempState[TaskCategories.UnrelatedRequests],
					apiLoaded: true,
					unrelatedRequestCount: action?.response?.countReadModel
				};
				return tempState;
			}
			return state;
		}

		case types.GET_ALL_ST_ENTITIES: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				const listOfStEntiies = action.response.data;
				// making ids as set to avoid duplicate ids;
				let ids = tempState[TaskCategories.Entities]?.ids ?? new Set();
				let items = {...tempState[TaskCategories.Entities]?.items};

				listOfStEntiies.forEach((e) => {
					e.label = e.stEntityShortName ? `${e.stEntityShortName} ${e.stEntityName}` : e.stEntityName;
				});

				listOfStEntiies.sort((a, b) => a.label.localeCompare(b.label));

				listOfStEntiies?.forEach((e) => {
					items[e.id] = {...items[e.id], ...e};
					ids.add(e.id);
				});

				tempState[TaskCategories.Entities] = {
					...tempState[TaskCategories.Entities],
					items: items,
					ids: ids,
					...action.response
				};
				return tempState;
			}
			return state;
		}

		case types.RESET_TASK_OVERVIEW_COUNT: {
			return {};
		}

		case types.RESET_LEVEL2_TASK_OVERVIEW_COUNT: {
			let tempState = _.cloneDeep(state);
			const nameOfStatusCount = getNameOfStatusCount(action.view);
			if (Object.keys(tempState).length > 0) {
				const items = tempState[action.taskCategoryId]?.items;
				action.ids.forEach((id) => {
					if (items?.[id]?.[nameOfStatusCount] !== undefined) {
						items[id][nameOfStatusCount] = {};
					} else {
						items[id] = {...items[id], [nameOfStatusCount]: {}};
					}
				});
				tempState[action.taskCategoryId] = {
					...tempState[action.taskCategoryId],
					items: items
				};
				return tempState;
			}
			return state;
		}
		default:
			return state;
	}
}

export function quickAccessDocumentReducer(state = initialstate.quickAccessDocument, action) {
	switch (action.type) {
		case types.GET_QUICK_ACCESS_DOCUMENT:
			if (action.response) {
				let propertyArray = Object.keys(action.response);
				let quickAccess = false;
				quickAccess = propertyArray.some((property) => !_.isEmpty(action.response[property]));
				return quickAccess;
			} else {
				return state;
			}
		default:
			return state;
	}
}
